<template>
  <modal :show="show" :show-close="false" class="white-content">
    <template #header>
      <h5 class="modal-title mb-0">{{ $t('terms.title') }} {{ version ? `(v${version})` : '' }}</h5>
    </template>
    <div class="terms-body">
      <pre class="terms-pre">{{ body }}</pre>
    </div>
    <div class="terms-footer mt-3 d-flex justify-content-end gap-2">
      <material-button variant="gradient" color="success" :disabled="submitting" @click="accept">
        {{ submitting ? $t('common.loading') : $t('terms.accept') }}
      </material-button>
    </div>
  </modal>
</template>

<script>
import api from "../services/api";
import Modal from "./Modal.vue";
import MaterialButton from "./MaterialButton.vue";

export default {
  name: "TermsAcceptanceModal",
  components: { Modal, MaterialButton },
  data() {
    return {
      show: false,
      submitting: false,
      latestId: null,
      version: null,
      body: "",
    };
  },
  methods: {
    async checkStatus() {
      try {
        const response = await api.get('/TermsAndConditions/status');
        const data = response.data;
        if (data && data.requiresAcceptance) {
          this.latestId = data.latestId;
          this.version = data.latestVersion;
          this.body = data.latestBody;
          this.show = true;
        } else {
          this.show = false;
        }
      } catch (error) {
        console.error('Terms status check failed:', error); // eslint-disable-line no-console
      }
    },
    async accept() {
      if (!this.latestId) return;
      this.submitting = true;
      try {
        await api.post('/TermsAndConditions/accept', { termsAndConditionsId: this.latestId });
        this.show = false;
      } catch (error) {
        console.error('Accept terms failed:', error); // eslint-disable-line no-console
        this.$toast?.error(this.$t('terms.acceptFailed'), { timeout: 0 });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.terms-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0.5rem 0.25rem;
}
.terms-pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
  font-size: 0.95rem;
  line-height: 1.4;
  margin: 0;
}
</style>
